import axios from '@/plugins/axios.js';

let inFlightRequest = null;

function startRequest() {
    const request = axios.get('/api/user-enrollments', { params: { per_page: 100 } });
    inFlightRequest = request;

    request
        .finally(() => {
            if (inFlightRequest === request) {
                inFlightRequest = null;
            }
        })
        .catch(() => {});

    return request;
}

export function fetchUserEnrollmentsSingleFlight({ force = false } = {}) {
    if (!inFlightRequest) {
        return startRequest();
    }

    if (!force) {
        return inFlightRequest;
    }

    return inFlightRequest.catch(() => {}).then(startRequest);
}
